/**
 * Qualifying life event types accepted by the CRM API (CRM-1914).
 * Values are sent as-is to the API, so the labels double as the stored value.
 */
export const qleTypeDropdown = () => [
  { label: 'Loss of Coverage', value: 'Loss of Coverage' },
  { label: 'Household Changes', value: 'Household Changes' },
  { label: 'Change in Residence', value: 'Change in Residence' },
  { label: 'Status or Eligibility Changes', value: 'Status or Eligibility Changes' },
  { label: 'Other Circumstance', value: 'Other Circumstance' },
];
